import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.jsx';
import {
  Hidden
} from '@material-ui/core';
import { withRouter } from "react-router";
import ReactGA from 'react-ga';
import HomeDesktop from './HomeDesktop/HomeDesktop.jsx';
import HomeMobile from './HomeMobile/HomeMobile.jsx';

import {contentData} from './content.jsx';

class Home extends Component{

  componentDidMount(){
    window.scrollTo(0,0)
    ReactGA.initialize('UA-134909612-1');
    ReactGA.pageview(window.location.pathname);
  }

  sendToPage = (event, url) => {
    this.props.history.push(url);
  } 

  goWork = (url, id) => {
    this.props.onGoToWork(id)
    this.props.history.push(url);
  } 
  

  render(){

    const {language} = this.props
    const content = contentData[language]

    let desktopView = (
      <Hidden smDown>
        <HomeDesktop content={content} sendToPage={this.sendToPage}  />
      </Hidden>
    )

    let mobileView = (
      <Hidden mdUp>
        <HomeMobile content={content} sendToPage={this.sendToPage}/>
      </Hidden>
    )
    
    return(
      <div>
        <HomeDesktop content={content} sendToPage={this.sendToPage} goWork={this.goWork} />
      </div>
    )
  }
}

export default withRouter(withStyles(styles)(Home));
